import axios from 'axios';
import { store } from '../app/store';
import { logout } from '../features/auth/authSlice';

// Development: React proxy (package.json "proxy") localhost:7264'e yönlendirir
// Production:  Aynı domain'de olduğu için relative URL direkt backend'e gider
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await axios.post('/api/Auth/refresh-token', null, { withCredentials: true });
        return api(originalRequest);
      } catch (refreshError) {
        store.dispatch(logout());
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
